import {View} from 'react-native'

import {useWebMediaQueries} from '#/lib/hooks/useWebMediaQueries'
import {FABInner, type FABProps} from './FABInner'

export const FAB = (_opts: FABProps) => {
  const {isDesktop} = useWebMediaQueries()
  const isComposeFab = _opts.testID === 'composeFAB'

  if (!isDesktop && !isComposeFab) {
    return <FABInner {..._opts} />
  }

  return <View />
}
